const selectors = {
  ITEM_SELECTOR: '.js-accordion-item',
  BUTTON_SELECTOR: '.js-accordion-button',
  CONTENT_SELECTOR: '.js-accordion-content',
  HEADING_BUTTON_CLASS: '.accordion-heading-capitalize .js-accordion-button .text'
}

class AccordionList extends HTMLElement {
  constructor() {
    super()

    this.init()
  }

  close(item) {
    const content = item.querySelector(selectors.CONTENT_SELECTOR)
    const button = item.querySelector(selectors.BUTTON_SELECTOR)
    if (button && content) {
      content.style.maxHeight = '0px'
      button.setAttribute('aria-expanded', 'false')
      item.removeAttribute('open')
    }
  }

  contentChange (item) {
    const config = { attributes: true, childList: true, subtree: true }

    const callback = (mutationList, observer) => {
      for (const mutation of mutationList) {
        if (mutation.type === 'childList') {
          const maxHeight = item.scrollHeight
          item.style.maxHeight = `${maxHeight}px`
        }
      }
    }

    const observer = new MutationObserver(callback)

    observer.observe(item, config)
  }

  updateHeight(item) {
    const content = item.querySelector(selectors.CONTENT_SELECTOR)
    if (content && item.hasAttribute('open')) {
      content.style.maxHeight = content.children[0].scrollHeight + 'px'
    }
  }

  open(item) {
    const content = item.querySelector(selectors.CONTENT_SELECTOR)
    const button = item.querySelector(selectors.BUTTON_SELECTOR)
    content.style.maxHeight = content.children[0].scrollHeight + 'px'
    button.setAttribute('aria-expanded', 'true')
    item.setAttribute('open', true)

    this.contentChange(content)
  }

  toggleDescription(item) {
    if (item && !item.hasAttribute('open')) {
      this.open(item)
    } else {
      this.close(item)
    }
  }

  init() {
    const list = this.querySelectorAll(selectors.ITEM_SELECTOR)
    if (list.length) {
      list.forEach((item) => {
        const button = item.querySelector(selectors.BUTTON_SELECTOR)
        const textTitle = item.querySelector(selectors.HEADING_BUTTON_CLASS)
        if (textTitle) {
          textTitle.innerHTML = textTitle.innerHTML.replace(/(^\w|\s\w)(\S*)/g, (_, m1, m2) => m1.toUpperCase() + m2.toLowerCase())
        }
        if (item.hasAttribute('open')) {
          this.open(item)
        }
        if (button) {
          const _this = this
          button.onclick = function (e) {
            if (location.pathname.includes('store-locator')) {
              e.stopPropagation()
            }
            _this.toggleDescription(item)
          }
        }

        // Listen for image-loaded event from liquid template
        const content = item.querySelector(selectors.CONTENT_SELECTOR)
        if (content) {
          content.addEventListener('image-loaded', () => {
            this.updateHeight(item)
          })
        }
      })

      // Handle window resize to recalculate heights for open accordions
      let resizeTimer
      window.addEventListener('resize', () => {
        clearTimeout(resizeTimer)
        resizeTimer = setTimeout(() => {
          list.forEach((item) => {
            if (item.hasAttribute('open')) {
              this.updateHeight(item)
            }
          })
        }, 250)
      })
    }
  }
}

customElements.define('accordion-list', AccordionList)
